import { SaveStateTypeEnum } from "src/app/shared/Models/enums/SaveStateTypeEnum";
import { BulkConfigurationType } from "./BulkConfigurationType.enum";
import { SettingType } from "./SettingType.enum";

export class SettingDto {
  settingType: SettingType;
  settingTypeName: string;
  settingValue: string;
  settingDataType: string;
  settingBoolValue: boolean;

  state?: SaveStateTypeEnum;
}
